import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import { MainButton } from '../MainButton';
import { MessengerLink } from '../MessengerLink';
import { WebimChat } from '../WebimChat';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ConsultantWidgetDesktop = /*#__PURE__*/function (_React$Component) {
  _inherits(ConsultantWidgetDesktop, _React$Component);

  var _super = _createSuper(ConsultantWidgetDesktop);

  function ConsultantWidgetDesktop() {
    var _this;

    _classCallCheck(this, ConsultantWidgetDesktop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "onHover", function () {
      return _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "outHover", function () {
      return _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (e) {
      e.preventDefault();

      _this.outHover();

      _this.props.toggleOpen(true);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      return _this.props.toggleOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var chatOpened = _this.props.chatOpened;
      var isHovered = _this.state.isHovered;

      if (chatOpened) {
        _this.close();
      } else if (isHovered) {
        _this.outHover();
      }
    });

    return _this;
  }

  _createClass(ConsultantWidgetDesktop, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          propStyles = _this$props.styles,
          messengersLinks = _this$props.messengersLinks,
          tooltip = _this$props.tooltip,
          chatOpened = _this$props.chatOpened,
          webimProps = _this$props.webimProps,
          onReady = _this$props.onReady;
      var isHovered = this.state.isHovered;
      var buttonsVisible = isHovered && !chatOpened;
      return /*#__PURE__*/_jsxs("div", {
        className: classnames(styles['container'], propStyles),
        children: [!chatOpened && /*#__PURE__*/_jsx("div", {
          className: classnames(styles['tooltip'], isHovered && styles['tooltip-offset']),
          children: tooltip
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['btn-container'],
          onMouseEnter: this.onHover,
          onMouseLeave: this.outHover,
          children: [/*#__PURE__*/_jsxs("div", {
            className: classnames(styles['links'], !buttonsVisible && styles['links-hidden']),
            children: [messengersLinks.map(function (linkParams) {
              return /*#__PURE__*/_jsx(MessengerLink, _objectSpread({}, linkParams), linkParams.type);
            }), /*#__PURE__*/_jsx(MessengerLink, {
              url: "/",
              type: "chat",
              onClick: this.open
            }, "chat")]
          }), /*#__PURE__*/_jsx(MainButton, {
            closedState: isHovered || chatOpened,
            onClick: this.onClick
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles['chat-container'],
          style: {
            display: chatOpened ? '' : 'none'
          },
          children: /*#__PURE__*/_jsx(WebimChat, _objectSpread(_objectSpread({}, webimProps), {}, {
            isOpen: chatOpened,
            onClose: this.close,
            onReady: onReady
          }))
        })]
      });
    }
  }]);

  return ConsultantWidgetDesktop;
}(React.Component);